export default __webpack_public_path__ + "static/media/graph-home.6d257480.png";